import './styles/helpers.scss';
import React from 'react';
import {createRoot} from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import App from './components/App';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import store from './redux/store';
import {Provider} from 'react-redux';
import EmptyPage from './components/EmptyPage';
import {noop} from './config';
import {buildHeaders} from './api';
// var bugsnagClient = process.env.NODE_ENV === 'development' ? bugsnag('s') : bugsnag('9ebfb3756e1d607599fd4ec8b6f33568')
// bugsnagClient.use(bugsnagReact, React)
//const ErrorBoundary = bugsnagClient.getPlugin('react')

// monkey patch fetch to append headers
window.fetch = (function(fetch){
	return (input, options)=>{
		const headers = {...buildHeaders(), ...(options?.headers || {})}
		return fetch(input, {
			...(options || {}),
			headers,
		})
	}
})(window.fetch)


if (process.env.NODE_ENV !== 'development' && new URL(document.location.href).searchParams.get('debug') !== 'true'){
	console.log = noop;
	console.warn = noop;
	console.error = noop;
}
const DevPage = React.lazy(()=>import('./pages/DevPage'))
function IntlApp(){
	return (
		<BrowserRouter>
			<Routes>
				<Route path={"/empty"} element={<EmptyPage/>} />
				<Route path={"/dev"} element={<DevPage/>} />
				<Route path={"/*"} element={<App/>} />
			</Routes>
		</BrowserRouter>);
}


function doRender() {
	const container = document.getElementById('root');
	if(container) {
		const root = createRoot(container)
		root.render(
			// <ErrorBoundary>
			<Provider store={store}>
				<IntlApp/>
			</Provider>
//		</ErrorBoundary>
		);
	}
}
// require('intl');
doRender();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

window.addEventListener("message", (event) => {
	if (event.data){
		console.log(event.data)
//		store.dispatch(event.data)
	}
}, false);
function mapStateToProps(state){
	return {
		locale: state.settings.locale
	};
}
